export default {
  label: {
    title: 'Settings',
    tabs: {
      style: 'Style',
      sharing: 'Sharing',
      users: 'Users with access',
      contract: 'Add Contract',
    },
  },
};
